import React from 'react';
import { LoadingContainer, LoadingIcon } from '@styled';

const LogInLoading = () => {
    return (
        <LoadingContainer minHeight={400} minHeightMobile={320}>
            <div className="px-4 text-center" style={{ maxWidth: '550px' }}>
                <h3 className="mb-3">
                    {`Logging you in .${String.fromCharCode(8201)}.${String.fromCharCode(8201)}.`}
                </h3>
                <div className="d-flex justify-center">
                    <LoadingIcon />
                </div>
            </div>
        </LoadingContainer>
    );
};

LogInLoading.propTypes = {};

export default LogInLoading;
